import { ActionPayload, createAction, createReducer } from "redux-act";
import produce from "immer";
import { reducerRegistry } from "../reducerRegistry";
import { Style } from "../style/style";
import { LayerInfo } from "../../interfaces/resourceInfo";

const reducerName = "layerTempStyle";

type LayerName = string;
type TempStyleId = string;

type LayerTempStyle = {
  id?: TempStyleId;
  style: Style;
};

type NewLayerTempStyle = LayerTempStyle & {
  layerName: string;
};

type LayerTempStyleUpdate = Partial<Omit<LayerTempStyle, "id">> & {
  layerName: string;
  nextId?: string;
};

export type LayerTempStyleState = Record<LayerName, Omit<LayerTempStyle, "layerName">>;

const initialState: LayerTempStyleState = {};

export const setLayerTempStyle = createAction<NewLayerTempStyle>(`${reducerName}/set`);
export const createLayerTempStyle = createAction<LayerInfo>(`${reducerName}/create`);
export const updateLayerTempStyle = createAction<{ layerName: string; style: Style }>(`${reducerName}/update`);
export const changeLayerTempStyle = createAction<LayerTempStyleUpdate>(`${reducerName}/change`);
export const resetLayerTempStyle = createAction(`${reducerName}/reset`);

export const reducer = createReducer({}, initialState);

reducer.on(
  setLayerTempStyle,
  produce((state: LayerTempStyleState, { layerName, id, style }: ActionPayload<typeof setLayerTempStyle>) => {
    state[layerName] = { id, style };
  }),
);

reducer.on(
  changeLayerTempStyle,
  produce((state: LayerTempStyleState, { layerName, style, nextId }: ActionPayload<typeof changeLayerTempStyle>) => {
    const { id: prevId, style: prevStyle } = state[layerName] || {};

    state[layerName] = {
      id: nextId || prevId,
      style: style || prevStyle,
    };
  }),
);

reducer.on(resetLayerTempStyle, () => initialState);

reducerRegistry.register(reducerName, reducer);
